import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { primaryColor } from '~theme';

const InfoButton = () => <Icon icon={faInfoCircle} />;

const Icon = styled(FontAwesomeIcon)`
  font-size: 20px;
  color: ${primaryColor};
`;

export default InfoButton;
